<template>
  <div
    id="app"
    class="woot-widget-wrap"
    :class="{
      'is-mobile': isMobile,
      'is-widget-right': !isLeftAligned,
      'is-bubble-hidden': hideMessageBubble,
      'has-navigation-bar': renderTabsBar && !isChatTabActive,
    }">
    <keep-alive>
      <router-view v-if="renderTabsBar"/>
    </keep-alive>
    <home v-if="!renderTabsBar && showHomePage"
      :has-fetched="hasFetched"
      :unread-message-count="unreadMessageCount"
      :show-popout-button="showPopoutButton"
    />
    <unread v-else-if="!showHomePage"
      :show-unread-view="showUnreadView"
      :has-fetched="hasFetched"
      :unread-message-count="unreadMessageCount"
      :hide-message-bubble="hideMessageBubble"
    />
    <navigation-bar v-if="renderTabsBar"
      :chat-tab-props="chatTabProps"
      @chat-tab-clicked="onChatTabClick"
    />
  </div>
</template>

<script>
import configMixin from "../mixins/configMixin";
import { sendGainSightEvent, SURFACE_KB_IN_CHAT_GS_EVENTS } from "../../gainSightIntegration";

export default {
  name: 'Router',
  mixins: [configMixin],
  components: {
    Home: () => import('./Home'),
    Unread: () => import('./Unread'),
    NavigationBar: () => import('./NavigationBar')
  },
  props: {
    hasFetched: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isLeftAligned: {
      type: Boolean,
      default: false,
    },
    showUnreadView: {
      type: Boolean,
      default: false,
    },
    showCampaignView: {
      type: Boolean,
      default: false,
    },
    hideMessageBubble: {
      type: Boolean,
      default: false,
    },
    unreadMessageCount: {
      type: Number,
      default: 0,
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChatTabActive: false,
    };
  },
  computed: {
    chatTabProps() {
      return {
        showUnreadView: this.showUnreadView,
        hasFetched: this.hasFetched,
        unreadMessageCount: this.unreadMessageCount,
        hideMessageBubble: this.hideMessageBubble,
        isMobile: this.isMobile,
        isLeftAligned: this.isLeftAligned,
        showPopoutButton: this.showPopoutButton,
        showCampaignView: this.showCampaignView,
      };
    },
    showHomePage() {
      return !this.showUnreadView && !this.showCampaignView;
    },
    renderTabsBar() {
      return !!this.isSurfaceKBInLiveChatEnabled && !this.showUnreadView && !this.showCampaignView;
    }
  },
  mounted() {
    window.bus.$on('chat-tab-clicked', () => {
      this.isChatTabActive = true;
      this.handleNudgeClick();
    })
    window.bus.$on('home-tab-clicked', () => {
      this.isChatTabActive = false;
      const tabName = 'home';
      sendGainSightEvent(SURFACE_KB_IN_CHAT_GS_EVENTS.WIDGET_TAB_CLICKED, {tabName});
    })
  },
  methods: {
    onChatTabClick() {
      this.isChatTabActive = true;
    },
    handleNudgeClick() {
      if (!this.isSurfaceKBInLiveChatEnabled) {
        return;
      }
      const route = {
        path: '/chat',
        query: {
          ...this.chatTabProps,
        }
      };
      this.$router.push(route);
    },
  }
};
</script>
